<div class="container">
  <canvas 
    [class.d-none]="!canShow || isLoading" 
    #canvas 
    id="chart-canvas">
  </canvas>
</div>
